module.exports = __webpack_public_path__ + "img/pz.eedca891.jpg";